import React from 'react';
import FooterColumn from './footerColumn';
import defaultAppStore from '/fallbacks/apple_store.svg';
import ChatIcon from '/fallbacks/chat.svg';
import defaultGoogleStore from '/fallbacks/google_store.svg';
import MailIcon from '/fallbacks/mail.svg';
import Payments from '/fallbacks/payment-methods-1.svg';
import PhoneIcon from '/fallbacks/telephone.svg';

const Footer = (data) => {
	const appstoreImg = data?.checkout_v3_footer_appstoreImg;
	const googleImg = data?.checkout_v3_footer_googleImg;
	const zendesk = data?.checkout_v3_footer_zendesk;

	const supportEmail = data?.footer_global_support_email
		? window.general_settings?.support_email
		: data?.custom_email_support_email;

	const phoneNumber = data?.footer_global_phone_number
		? window.general_settings?.phone_number
		: data?.footer_phone_support_number;

	const logo = data?.footer_global_logo ? window.general_settings?.logo_white : data?.footer_custom_logo;

	const paymentsIcon = data?.footer_payments_icon ? data?.footer_payments_icon : Payments;

	const handleZendeskClick = () => {
		window.zE.show();
		window.zE.activate();
	};

	return (
		<footer className="footer" style={{ backgroundColor: data?.footer_section_background_color }}>
			<div className="footer__seperator">
				<div className="footer__seperatorLine"></div>
			</div>
			<div className="footer__innerContainer">
				<div className="footer__logoContainer">
					<img
						src={logo}
						alt={`${window.general_settings.brand_name} image`}
						className="footer__logo image"
					/>
					<p style={{ color: data?.footer_description_text_color }} className="footer__logoContainerText">
						{data.tr_footer_product_description}
					</p>
					{data.footer_app_store_links && (
						<div className="footer__logoContainerStores">
							<a href={data.footer_apple_appstore_link} target="_blank">
								<img
									src={appstoreImg || defaultAppStore}
									alt={`${window.general_settings.brand_name} Apple store`}
								/>
							</a>
							<a href={data.footer_google_store_link} target="_blank">
								<img
									src={googleImg || defaultGoogleStore}
									alt={`${window.general_settings?.brand_name} Google store`}
								/>
							</a>
						</div>
					)}
				</div>
				{data.footer_link_columns &&
					data.footer_link_columns.map((column, index) => (
						<FooterColumn
							data={data}
							key={index}
							index={index}
							links={column.footer_links_column_repeater}
							heading={column.tr_footer_links_column_title}
						/>
					))}

				<div className="footer__listContainer footer__listContainer--3">
					<h3 className="footer__heading" style={{ color: data?.footer_heading_text_color }}>
						{data.tr_footer_customer_care_label}
					</h3>
					<div className="footer__help">
						<ul className="footer__list footer__list--customerCare">
							<li className="footer__listItem footer__listItem--white">
								<div
									className="footer__icon"
									style={{
										'--icon-color': data?.footer_support_icons_color,
										maskImage: `url('${MailIcon}')`,
										WebkitMaskImage: `url('${MailIcon}')`,
									}}
								></div>
								<a
									style={{
										'--support-link-color': data?.footer_support_links_text_color,
										'--support-link-color-hover': data?.footer_link_text_color_hover,
									}}
									className="link-static-color"
									href={`mailto:${supportEmail}`}
								>
									{data.tr_footer_email_support_label}
								</a>
							</li>
							<li
								className="footer__listItem footer__listItem--white"
								onClick={() => {
									handleZendeskClick();
								}}
							>
								<div
									id="test-link"
									className="footer__icon"
									style={{
										'--icon-color': data?.footer_support_icons_color,
										maskImage: `url('${ChatIcon}')`,
										WebkitMaskImage: `url('${ChatIcon}')`,
									}}
								></div>
								<a
									className="link-static-color"
									style={{
										'--support-link-color': data?.footer_support_links_text_color,
										'--support-link-color-hover': data?.footer_link_text_color_hover,
									}}
									href={zendesk == false && `mailto: ${supportEmail}`}
								>
									{data.tr_footer_chat_support_label}
								</a>
							</li>
							<li className="footer__listItem footer__listItem--white">
								<div
									className="footer__icon"
									style={{
										maskImage: `url('${PhoneIcon}')`,
										WebkitMaskImage: `url('${PhoneIcon}')`,
										'--icon-color': data?.footer_support_icons_color,
									}}
								></div>
								<a
									className="link-static-color"
									style={{
										'--support-link-color': data?.footer_support_links_text_color,
										'--support-link-color-hover': data?.footer_link_text_color_hover,
									}}
									href={`tel:${phoneNumber}`}
								>
									{phoneNumber}
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div className="footer__ribbon" style={{ background: data?.copyrights_background_color }}>
				<div className="footer__innerRibbonWrapper">
					<div className="footer__ribbonContent">
						<div style={{ color: data.copyrights_text_color }}>
							<span>©</span>
							<span>{new Date().getFullYear()}</span> <span>{data.tr_footer_copyrights_text}</span>
						</div>
					</div>
					<img
						className="footer__paymentLogos"
						src={paymentsIcon}
						alt={`${window.general_settings.brand_name} image`}
					/>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
